import React, {useState, useCallback} from 'react';
import Box from '@mui/material/Box';
import Popper from '@mui/material/Popper';
import Action from '../../assets/action-button.svg';
import { List, ListItem, ListItemText, Divider } from '@mui/material';
import SidebarNav from '../CheckoutSidebar/SidebarNav';
import { useLocation, useNavigate } from 'react-router-dom';
import ReusableDrawer from '../CheckoutSidebar/ReusableDrawer';
import SidebarForm from '../CheckoutSidebar/SidebarForm';
import RateContent from '../CheckoutSidebar/RateContent';
import { useWindowResize } from '../../hooks/useWindowResize';
import TabPanel from '../CheckoutSidebar/TabPanel';
import { Troubleshoot } from '@mui/icons-material';



export default function ActionPopper({item_details}) {
  console.log(item_details)
  const location = useLocation();
  const navigate = useNavigate()
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openGiftDrawer, setOpenGiftDrawer] = useState(false);
  const [openRateDrawer, setOpenRateDrawer] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [drawerType, setDrawerType] = useState(null); 
    const [openCourseDrawer, setOpenCourseDrawer] = useState(false)
    const {pathname} = useLocation();
  
  const { windowWidth, isMobile, breakpoint } = useWindowResize();

  
  const handleDrawerCourseClose = () => {
    setOpenCourseDrawer(false);
    setDrawerType(null);
  };


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen((prevOpen) => !prevOpen);
  };

  const handleDrawerGiftClose = () => {
    setOpenGiftDrawer(false);
    setDrawerType(null);
    
  };
  const handleDrawerRateClose = () => {
    setOpenRateDrawer(false);
    setDrawerType(null);
  };
  const handleReOrder = ()=>{
    navigate(`${pathname}?productId=${item_details?.productId}`)
    if (location.pathname === `/product/giftshop/order-history`) {
      setOpenGiftDrawer(true);
      if (isMobile) {
        navigate(`/product/gift-details/checkout-form?productId=${item_details.productId}`);
      }
    }
    else {
      setOpenCourseDrawer(true);
      if (isMobile) {
        navigate(`/product/course-details/checkout-form?productId=${item_details.productId}`);
      }
    }
  }
  console.log(item_details?.productId)
  const handleRateDrawer = ()=>{

    navigate(`${pathname}?productId=${item_details?.productId}`)
    setOpenRateDrawer(true)
    if (location.pathname === '/product/giftshop/order-history') {
      setOpenRateDrawer(true);
      if (isMobile) {
        navigate(`/product/giftshop/rating?productId=${item_details.productId}`);
      }
    }

    // On Order History Page
    if (location.pathname ===  '/product/digital-course/order-history') {
      setOpenRateDrawer(true);
      if (isMobile) {
        navigate(`/product/digital-course/rating?productId=${item_details.productId}`);
      }
    }
  }
  return (
    <div>
      <button type="button" onClick={handleClick} style={{border:'none'}}>
        <img src={Action} alt="Action button" style={{cursor:'pointer'}}/>
      </button>
      <Popper open={open} anchorEl={anchorEl} placement="bottom">
        <Box
          sx={{
            bgcolor: 'background.paper',
            boxShadow: 3,
            borderRadius: 1,
          }}
        >
          <List sx={{padding:0, bgcolor:'inherit', borderRadius:'4px'}}>
            <ListItem button sx={{p:1, textAlign:'center', cursor:'pointer'}} onClick={handleRateDrawer}>
              <ListItemText primary="Rate and review" sx={{fontSize:'.8rem'}}/>
            </ListItem>
            <Divider />
            <ListItem button sx={{p:1, textAlign:'center', cursor:'pointer'}} onClick={handleReOrder}>
              <ListItemText primary="Re-order" sx={{fontSize:'.8rem'}}/>
            </ListItem>
          </List>
        </Box>
        <ReusableDrawer
      state={openRateDrawer}
      drawerType={drawerType}
      onClose={handleDrawerRateClose}
      SidebarContent={SidebarNav}
      FormContent={RateContent}
      setOnClose={setOpenRateDrawer}
      width="35%"
    />
    <ReusableDrawer
      state={openGiftDrawer}
      drawerType={drawerType}
      onClose={handleDrawerGiftClose}
      SidebarContent={SidebarNav}
      FormContent={SidebarForm}
      item_details={item_details}
      setOnClose={setOpenGiftDrawer}
      title="Checkout"
      subtitle="Provide the recipient's details to proceed with your checkout seamlessly."
      width="35%"
    />
        <ReusableDrawer
      state={openCourseDrawer}
      drawerType={drawerType}
      courseState={openCourseDrawer}
      onClose={handleDrawerCourseClose}
      TabPanel={TabPanel}
      setOnClose={setOpenCourseDrawer}
      title="Checkout"
      width="35%"
    />
      </Popper>
    </div>
  );
}
